//$.fn.dataTable.FixedHeader.prototype._positions =
export const FixedHeader_positions = function () {
    var dt = this.s.dt;
    var table = dt.table();
    var position = this.s.position;
    var dom = this.dom;
    var tableNode = $(table.node());

    // Need to use the header and footer that are in the main table,
    // regardless of if they are clones, since they hold the positions we
    // want to measure from
    var thead = tableNode.children('thead');
    var tfoot = tableNode.children('tfoot');
    var tbody = dom.tbody;

    position.scrollLeftFixedHeader = tableNode.parent().scrollLeft();
    position.visible = tableNode.is(':visible');
    position.width = tableNode.outerWidth();
    position.left = tableNode.offset().left + tableNode.parent().scrollLeft();
    position.theadTop = thead.offset().top;
    position.tbodyTop = tbody.offset().top;
    position.tbodyHeight = tbody.outerHeight();
    position.theadHeight = position.tbodyTop - position.theadTop;

    if (tfoot.length) {
        position.tfootTop = tfoot.offset().top;
        position.tfootBottom = position.tfootTop + tfoot.outerHeight();
        position.tfootHeight = position.tfootBottom - position.tfootTop;
    } else {
        position.tfootTop = position.tbodyTop + tbody.outerHeight();
        position.tfootBottom = position.tfootTop;
        position.tfootHeight = position.tfootTop;
    }
};

//$.fn.dataTable.FixedHeader.prototype._clone =
export const FixedHeader_clone = function (item, force) {
    var dt = this.s.dt;
    var itemDom = this.dom[item];
    var itemElement = item === 'header' ?
        this.dom.thead :
        this.dom.tfoot;

    if (!force && itemDom.floating) {
        // existing floating element - reuse it
        itemDom.floating.removeClass('fixedHeader-floating fixedHeader-locked');
    } else {
        if (itemDom.floating) {
            itemDom.placeholder.remove();
            this._unsize(item);
            itemDom.floating.children().detach();
            itemDom.floating.remove();
        }

        itemDom.floating = $(dt.table().node().cloneNode(false))
            .removeAttr('data-columns')
            .css('table-layout', 'fixed')
            .attr('aria-hidden', 'true')
            .removeAttr('id')
            .append(itemElement);

        // Insert a fake thead/tfoot into the DataTable to stop it jumping around
        itemDom.placeholder = itemElement.clone(false);
        itemDom.placeholder
            .find('*[id]')
            .removeAttr('id');

        itemDom.host.prepend(itemDom.placeholder);

        // Clone widths
        this._matchWidths(itemDom.placeholder, itemDom.floating);
    }
};

//$.fn.dataTable.FixedHeader.prototype._modeChange =
export const FixedHeader_modeChange = function (mode, item, forceChange) {
    var dt = this.s.dt;
    var itemDom = this.dom[item];
    var position = this.s.position;

    // Record focus. Browser's will cause input elements to loose focus if
    // they are inserted else where in the doc
    var tablePart = this.dom[item === 'footer' ? 'tfoot' : 'thead'];
    var focus = $.contains(tablePart[0], document.activeElement) ?
        document.activeElement :
        null;

    if (item == 'header') {
        return
    }

    if (focus) {
        focus.blur();
    }
    if (mode === 'in-place') {
        // Insert the header back into the table's real header
        if (itemDom.placeholder) {
            itemDom.placeholder.remove();
            itemDom.placeholder = null;
        }

        this._unsize(item);

        if (item === 'header') {
            itemDom.host.prepend(tablePart);
        } else {
            itemDom.host.append(tablePart);
        }

        if (itemDom.floating) {
            itemDom.floating.remove();
            itemDom.floating = null;
        }

        const event = new CustomEvent('fixedHeader:hide');

        document.dispatchEvent(event);
        dt.table().node().dispatchEvent(event);
    } else if (mode === 'in') {
        // Remove the header from the read header and insert into a fixed
        // positioned floating table clone
        this._clone(item, forceChange);

        var container = document.createElement('div');
        var tableUniqueId = itemDom.floating[0].dataset.tableUniqueId;
        var properlyWidth = $(document).find('.dataTables_scrollBody table[data-table-unique-id="' + tableUniqueId + '"]').parent().width();
        container.setAttribute('data-table-unique-id', tableUniqueId);
        container = $(container).append(itemDom.floating);
        itemDom.floating = container;
        itemDom.floating
            .addClass('fixedHeader-floating position-fixed fixedHeader-container')
            .css(item === 'header' ? 'top' : 'bottom', this.c[item + 'Offset'])
            .css('width', properlyWidth + 'px');

        if (position.left > 0) {
            itemDom.floating.css('left', position.left + 'px');
        }

        itemDom.floating.appendTo('body');

        $(document).find('.fixedHeader-container').scrollLeft(
            position.scrollLeftFixedHeader ? position.scrollLeftFixedHeader : 0
        );

        const event = new CustomEvent('fixedHeader:show', {
            detail: {
                container: itemDom.floating[0]
            }
        });

        document.dispatchEvent(event);
        dt.table().node().dispatchEvent(event);

        if (item === 'footer') {
            itemDom.floating.css('top', '');
        }
    } else if (mode === 'below') { // only used for the header
        // Fix the position of the floating header at base of the table body
        this._clone(item, forceChange);

        itemDom.floating
            .addClass('fixedHeader-locked')
            .css('top', position.tfootTop - position.theadHeight)
            .css('left', position.left + 'px')
            .css('width', position.width + 'px');
    } else if (mode === 'above') { // only used for the footer
        // Fix the position of the floating footer at top of the table body
        this._clone(item, forceChange);

        itemDom.floating
            .addClass('fixedHeader-locked')
            .css('top', position.tbodyTop)
            .css('left', position.left + 'px')
            .css('width', position.width + 'px');
    }

    // Restore focus if it was lost
    if (focus && focus !== document.activeElement) {
        setTimeout(function () {
            focus.focus();
        }, 10);
    }

    this.s.scrollLeft.header = -1;
    this.s.scrollLeft.footer = -1;
    this.s[item + 'Mode'] = mode;
};
